import { useTheme as e } from "styled-components";
function r() {
  return e();
}
export {
  r as useTheme
};
//# sourceMappingURL=useTheme.es.js.map
